import { FiltersV2ApplyButton, FiltersV2PanelProps, useFiltersV2Select } from "PFApp/components/filters_v2";
import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import { FooterRendererArgs } from "PFComponents/side_panel/side_panel";
import { useTranslation } from "react-i18next";

import { SavedFiltersCollectionBadges } from "../../saved_filters_collection/parts/saved_filters_collection_badges";
import { SaveFiltersButton } from "../../saved_filters_collection/save_filters_button";
import css from "../filters_v2_panel.module.scss";

export const FiltersV2PanelFooter = ({
  onSidePanelClose,
  savedFiltersProps
}: FooterRendererArgs & Pick<FiltersV2PanelProps, "savedFiltersProps">) => {
  const { t } = useTranslation("translation");
  const { isAutoRefreshOn, collection } = useFiltersV2Select("isAutoRefreshOn", "collection");

  return (
    <>
      {collection && <SavedFiltersCollectionBadges {...savedFiltersProps} />}
      <Inline wrap="wrap" gap="spacingLg" justifyContent="space-between" className={css.footerRow}>
        <Button kind={isAutoRefreshOn ? "primary" : "secondary"} onClick={onSidePanelClose}>
          {t(isAutoRefreshOn ? "done" : "cancel")}
        </Button>
        <Inline gap="spacingLg" alignItems="center">
          {collection && <SaveFiltersButton {...savedFiltersProps} />}
          <FiltersV2ApplyButton />
        </Inline>
      </Inline>
    </>
  );
};
